import * as React from 'react';
import { ErrorView } from 'ts/passwordless-login/components/pages/error/ErrorView';
import * as ConfigService from 'ts/config/ConfigService';

const TogglesFailedView = () => (
  <ErrorView
    title={'Something went wrong'}
    errorMessage={
      "Sorry, looks like we're having some issues. Go back and try again or come back later."
    }
    backHref={ConfigService.getHomepageUrl()}
  />
);

export { TogglesFailedView };
